<template>
    <div class="house-page-rented">
        <Breadcrumb />
        <!-- <edit-house-comp :class="{'fixed': listIsFixed}"></edit-house-comp> -->
        <house-detail-rented-comp :class="{'fixed': listIsFixed}"></house-detail-rented-comp>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import HouseDetailRentedComp from '@/components/landlord/houseStatus/houseManagement/HouseDetailRentedComp.vue';

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('house-detail-rented-head')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('house-detail-rented-head')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    components: {
        Breadcrumb,
        HouseDetailRentedComp
    }
}
</script>
<style lang="scss" scoped>
    .house-page-rented{
        position: relative;
        margin-top: 82px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/HouseDetailRented.vue